"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _Button = _interopRequireDefault(require("./Button"));
exports.default = _Button.default;